import _get from "lodash/get";

/**
 * redux selectors for accessing search state
 */

/**
 * Return the search term
 * @param state
 * @returns {*}
 */
export const isSearchActive = (state) => {
    return _get(state, "search.searchIsActive", "");
};

/**
 * Return error, if any
 * @param state
 * @returns {*}
 */
export const getSearchError = (state) => {
    return _get(state, "search.error", null);
};

/**
 * Return search results
 * @param state
 * @returns {*}
 */
export const getSearchResults = (state) => {
    return _get(state, "search.searchResults", []);
};

/**
 * get the search term
 * @param state
 * @returns {*}
 */
export const getSearchTerm = (state) => {
    return _get(state, "search.searchTerm", "");
};
